@if ($outlined()) {
  <div class="item-status-cell outlined">
    <w-badge
      [label]="$statusLabel()"
      [tooltip]="$statusLabel()"
      [color]="$statusStyle().color"
      [backgroundColor]="$statusStyle().backgroundColor"
      [borderColor]="$statusStyle().borderColor"
      [onlyShowTooltipIfOverflow]="true"
      size="xs"
      mode="squared" />

    @if ($locked()) {
      <i class="fa-regular fa-lock line-lock" pTooltip="You can't change this line" tooltipStyleClass="wb-dark-tooltip" tooltipPosition="top" [showDelay]="200" appendTo="body" aria-label="You can't change this line"></i>
    }
  </div>
} @else {
  <div class="item-status-cell">
    <div class="status-name" [class.locked]="$locked()">
      <w-badge
        [label]="$statusLabel()"
        [tooltip]="$statusLabel()"
        [color]="$statusStyle().color"
        [backgroundColor]="$statusStyle().backgroundColor"
        [onlyShowTooltipIfOverflow]="true"
        mode="squared"
        borderColor="transparent" />

      @if ($locked()) {
        <i class="fa-regular fa-lock line-lock" pTooltip="You can't change this line" tooltipStyleClass="wb-dark-tooltip" tooltipPosition="top" [showDelay]="200" appendTo="body" aria-label="You can't change this line"></i>
      }
    </div>
  </div>
}
